import { inject } from '@angular/core';
import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { finalize } from 'rxjs';
import { AppStateService } from '../services/app-state.service';

export const queryStateInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const state: AppStateService = inject(AppStateService);
  state.loading++;

  return next(req).pipe(
    finalize(() => {
      state.loading--;
    })
  );
};
